import { cx } from "@/lib/utils";

export const GripVerticalIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg className={cx("w-4 h-4 text-gray-400", className)} fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
    <circle cx="9" cy="5" r="1" fill="currentColor" />
    <circle cx="9" cy="12" r="1" fill="currentColor" />
    <circle cx="9" cy="19" r="1" fill="currentColor" />
    <circle cx="15" cy="5" r="1" fill="currentColor" />
    <circle cx="15" cy="12" r="1" fill="currentColor" />
    <circle cx="15" cy="19" r="1" fill="currentColor" />
  </svg>
);
